import { c as _c } from "react/compiler-runtime";
import { useStrictContext } from '@cc-shopping/hooks/useStrictContext';
import { createContext, type PropsWithChildren } from 'react';
type CreditCardCompareColumnContextValue = {
  index: number;
};
const CreditCardCompareColumnContext = createContext<CreditCardCompareColumnContextValue | null>(null);
type CreditCardCompareColumnContextProviderProps = {
  value: CreditCardCompareColumnContextValue;
};
export const MAXIMUM_COLUMNS_DESKTOP = 3;
export const MAXIMUM_COLUMNS_MOBILE = 2;
export function CreditCardCompareColumnContextProvider(t0) {
  const $ = _c(3);
  const {
    children,
    value
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = <CreditCardCompareColumnContext.Provider value={value}>{children}</CreditCardCompareColumnContext.Provider>;
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function useCreditCardCompareColumnContext() {
  const creditCardCompareColumnContext = useStrictContext(CreditCardCompareColumnContext);
  return creditCardCompareColumnContext;
}